<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      title="订单明细"
      id-key="RecordId"
      :data="data"
      :save-func="() => {}"
      form-label-width="85px"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-descriptions>
          <el-descriptions-item label="订单编号">
            <span
              v-clipboard:copy="data.OrderNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
            >
              {{ data.OrderNo }}<i class="el-icon-copy-document"></i></span
          ></el-descriptions-item>
          <el-descriptions-item label="下单时间">{{
            data.OrderDate
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="所属商家">{{
            data.StoreName
          }}</el-descriptions-item> -->
        </el-descriptions>
        <el-row class="row-border" style="padding: 0">
          <el-table :data="OrderInfos" style="width: 98%; margin: 0 auto">
            <el-table-column label="收货信息" width="160px">
              <template slot-scope="{ row }">
                <div style="text-align: left">
                  <span>收货人：{{ row.ReceivingPerson }}</span
                  ><br />
                  <span>联系电话：{{ row.ReceivingPhone }}</span
                  ><br />
                  <span>收货地址：{{ row.ReceivingAddress }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="买家信息" width="160px">
              <template slot-scope="{ row }">
                <div style="text-align: left">
                  <span>买家：{{ row.NickName }}</span
                  ><br />
                  <!-- <span>{{ row.PersonCode }}</span
                  ><br /> -->
                  <span>买家留言：{{ row.Remark }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="付款信息">
              <template slot-scope="{ row }">
                <div style="text-align: left">
                  <span v-if="row.PayType == 0">付款方式：微信支付<br /></span>
                  <span
                    >实付金额：{{
                      Number(row.PayAmount || 0).toFixed(2)
                    }}
                    元</span
                  ><br />
                  <span
                    >优惠金额：{{
                      Number(row.CouponAmount ?? 0).toFixed(2)
                    }}
                    元</span
                  ><br />
                  <span
                    v-clipboard:copy="data.OrderNo"
                    v-clipboard:success="copySuccess"
                    v-clipboard:error="copyError"
                    >支付凭证：{{ row.PayNo }}
                    <i class="el-icon-copy-document"></i
                  ></span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="配送信息" width="195px">
              <template slot-scope="{ row }">
                <div style="text-align: left">
                  <span v-if="row.PayType == 1">配送方式：自提<br /></span>
                  <span v-else>配送方式：物流配送<br /></span>
                  <span>配送时间：{{ row.SendDate }} </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        订单日志
        <el-row class="row-border" style="padding-right: 0; padding-top: 10px">
          <el-col :span="24" style="padding: 10px">
            <el-steps :active="OrderLog.length">
              <el-step
                icon="el-icon-circle-check"
                v-for="item in OrderLog"
                :key="item.RecordId"
                :title="item.Action"
                :description="(item.Remark || '') + ' ' + item.AddTime"
              ></el-step>
            </el-steps>
          </el-col>
        </el-row>
        物流信息
        <el-row class="row-border" style="padding: 10px">
          <el-col :span="8">
            <!-- <span v-if="data.PayType == 1">发货方式：自提<br /></span> -->
            <span>发货方式：物流配送<br /></span>
            发货时间： {{ data.SendDate }}<br />
            物流企业：{{ data.ExpressCompanyName }}<br />
            物流单号：{{ data.ExpressNo }}
          </el-col>
          <el-col :span="16">
            <span>物流状态：{{ Logistics.logisticsStatusDesc }}</span>
            <div class="infinite-list" style="overflow: auto; margin-top: 10px">
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(activity, index) in Logistics.fullTraceDetail"
                  :key="index"
                  :timestamp="activity.time"
                >
                  {{ activity.desc }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-col>
        </el-row>
        <br />
        商品明细
        <el-row style="padding-top: 5px">
          <el-col :span="24">
            <el-table border :data="OrderGoods" size="mini">
              <el-table-column
                prop="GoodsName"
                label="商品信息"
                width="400px"
                align="center"
              >
                <template slot-scope="{ row }">
                  <el-row style="text-align: left">
                    <el-col :span="6">
                      <el-image
                        ref="img"
                        :src="'/api' + row.GoodsCover"
                        style="width: 80px"
                    /></el-col>
                    <el-col :span="18">
                      {{ row.GoodsName }}<br />
                      规格：{{ row.AttributeName }}<br />
                      货号：{{ row.AttributeCode }}</el-col
                    >
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="PlatformPrice" label="单价" align="center">
                <template slot-scope="{ row }">
                  {{ Number(row.PlatformPrice || 0).toFixed(2) }}
                </template></el-table-column
              >
              <el-table-column
                prop="MainunitCount"
                label="数量"
                align="center"
              />
              <el-table-column prop="ActivityPrice" label="优惠" align="center">
                <template slot-scope="{ row }">
                  {{
                    row.activity_id > 0
                      ? Number(
                          row.ActivityPrice - row.PlatformPrice || 0
                        ).toFixed(2)
                      : Number(
                          row.PlatformPrice - row.PlatformPrice || 0
                        ).toFixed(2)
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="SumAmount" label="小计" align="center"
                ><template slot-scope="{ row }">
                  {{ Number(row.SumAmount || 0).toFixed(2) }}
                </template></el-table-column
              >
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="19">
            <div style="width: 100%; height: 100px"></div>
          </el-col>
          <el-col :span="5" style="text-align: right; padding: 10px 0">
            <table style="width: 100%">
              <tr>
                <td>商品金额：</td>
                <td>¥{{ Number(data.GoodsAmount || 0).toFixed(2) }}</td>
              </tr>
              <tr>
                <td>运费金额：</td>
                <td>
                  ¥{{ Number(data.RealityExpressamount || 0).toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td>优惠金额：</td>
                <td>
                  -¥{{ Number(data.SubTotal - data.PayAmount || 0).toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td>订单总额：</td>
                <td>¥{{ Number(data.SubTotal || 0).toFixed(2) }}</td>
              </tr>
              <tr>
                <td>实付金额：</td>
                <td>¥{{ Number(data.PayAmount || 0).toFixed(2) }}</td>
              </tr>
              <tr v-if="data.OrderState == 5">
                <td>售后状态：</td>
                <td>
                  <span v-if="data.AfterSalesState == 1">待商家审核</span>
                  <span v-if="data.AfterSalesState == 2">商家审核通过</span>
                  <span v-if="data.AfterSalesState == 3">商家审核不通过</span>
                  <span v-if="data.AfterSalesState == 4">待买家退货</span>
                  <span v-if="data.AfterSalesState == 5">待商家收货</span>
                  <span v-if="data.AfterSalesState == 6">商家已退款</span>
                </td>
              </tr>
              <!-- <tr v-if="data.OrderState == 5">
                <td>发货状态：</td>
                <td>
                  <span v-if="data.SendState == 1">待发货</span>
                  <span v-if="data.SendState == 2">待收货</span>
                  <span v-if="data.SendState == 3">已完成</span>
                </td>
              </tr>
              <tr v-if="data.OrderState == 6">
                <td>取消状态：</td>
                <td>
                  <span v-if="data.CancelState == 1">待付款取消</span>
                  <span v-if="data.CancelState == 2">待发货取消</span>
                  <span v-if="data.CancelState == 3">待收货取消</span>
                  <span v-if="data.CancelState == 4">已收货取消</span>
                </td>
              </tr> -->
            </table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <!-- <el-button type="success" disabled>快递信息</el-button> -->
        <template
          v-if="
            data.OrderState == 5 &&
            data.AfterSalesState == 1 
          "
        >
          <el-button size="mini" type="primary" @click="show1 = true"
            >同意退款</el-button
          >
          <el-button size="mini" type="danger" @click="show2 = true"
            >拒绝退款</el-button
          >
        </template>
        <template
          v-if="
            data.OrderState == 5 &&
            data.AfterSalesState == 5 
          "
        >
          <el-button size="mini" type="primary" @click="show3 = true"
            >确认收货并退款</el-button
          >
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>

    <el-dialog
      title="退款"
      :visible.sync="show1"
      :before-close="beforeClose"
      width="500px"
    >
      <el-form>
        <el-form-item
          label="商家反馈"
          label-width="75px"
          v-if="data.SendState > 0"
        >
          <el-select
            size="mini"
            v-model="Back"
            style="width: 300px"
            placeholder="请选择商家反馈"
          >
            <el-option
              label="同意申请，需用户填写退货信息并寄回"
              :value="true"
            ></el-option>
            <el-option
              label="同意申请，商品无需寄回"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款金额" label-width="75px">
          <el-input
            type="number"
            v-model="RefundAmount"
            style="width: 300px"
            placeholder="请填写退款金额"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="备注"
          :label-width="data.SendState > 0 ? '75px' : '50px'"
        >
          <el-input
            type="textarea"
            v-model="BackRemark"
            style="width: 300px"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passRefund" size="mini"
          >确 认</el-button
        >
        <el-button @click="show1 = false" size="mini">取 消</el-button>
      </template>
    </el-dialog>
    <el-dialog
      title="拒绝退款"
      :visible.sync="show2"
      :before-close="beforeClose"
      width="30%"
    >
      <el-form>
        <el-form-item label="备注" label-width="50px">
          <el-input
            type="textarea"
            v-model="BackRemark"
            style="width: 300px"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refuseRefund" size="mini"
          >确 认</el-button
        >
        <el-button @click="show2 = false" size="mini">取 消</el-button>
      </template>
    </el-dialog>

    <el-dialog
      title="确认收货并退款"
      :visible.sync="show3"
      :before-close="beforeClose"
      width="30%"
    >
      <el-form>
        <!-- <el-form-item label="备注" label-width="50px">
          <el-input
            type="textarea"
            v-model="BackRemark"
            style="width: 300px"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="退款金额" label-width="75px">
          {{ data.RefundAmount }}
        </el-form-item>
      </el-form>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="backPass" size="mini"
          >确 认</el-button
        >
        <el-button @click="show3 = false" size="mini">取 消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderNo: "", //订单编号
        CustomerId: null, //客户编号
        CustomerName: "", //客户名称
        Mobile: "", //手机号
        CustomerType: null, //客户类型 - 1:零售
        GoodsAmount: null, //商品金额
        Quantity: null, //商品数量
        Amount: null, //订单金额
        PayAmount: null, //实付金额
        Point: null, //积分
        AddTime: null, //订单时间
        OrderState: null, //订单状态 - 0:未确认 1:正常执行中 2:退款中 3:已完成 4:已取消
        OrderStateText: "",
        SendState: null, //发货状态 - 0:未发货 1:已发货 2:已收货 3:退货中 4:退货待收 5:已退货
        SendStateText: "",
        PayState: null, //付款状态 - 0:未付款 1:已付款 2:退款中 3:已退款
        PayStateText: "",
        RefundAmount: 0, //退款金额
        RefundState: null, //退款状态 - 0:无 1:退款待审 2:客户取消 3:同意退款 4:拒绝退款
        RefundStateText: "",
        FreightMode: null, //配送方式 - 0:异地配送 1:本地配送 2:自提
        ExpressName: "", //配送公司
        ExpressNo: "", //配送单号
        Freight: null, //配送金额
        SubTotal: null, //小计金额
        CouponName: "", //优惠券名称
        CouponAmount: null, //优惠金额
        Person: "", //收货联系人
        Phone: "", //收货联系电话
        Address: "", //收货地址
        Reason: "", //退款原因
        ApplyTime: null, //退款申请时间
        Feedback: "", //商家反馈
        Remark: "", //商家备注
        BackExpressName: "", //退货配送公司
        BackExpressNo: "", //退货配送单号
        BackTime: null, //退货时间
      },
      OrderGoods: [], //商品信息
      OrderLog: [], //操作日志
      DeliverList: [], //发货信息
      RefundList: [], //退货商品
      api: require("@/api/sale/order/order").default,
      ogApi: require("@/api/sale/order/orderGoods").default,
      olApi: require("@/api/sale/order/orderLog").default,
      rgApi: require("@/api/sale/order/returnGoods").default,
      show1: false,
      show2: false,
      show3: false,
      BackRemark: "", //退款备注
      Back: false, //退款是否需要寄回商品
      OrderInfos: [],
      Logistics: [],
      RefundAmount: null, //退款金额

      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  computed: {},
  methods: {
    copySuccess() {
      this.$message.success("复制成功");
    },
    copyError() {
      this.$message.error("复制失败");
    },
    onDetailsOpened(data) {
      this.RefundAmount = null;
      var params = { OrderMainId: this.data.RecordId };
      this.api.getOrderInfo(this.data.RecordId).then((res) => {
        if (res.Data) {
          this.data = res.Data;
          this.RefundAmount = res.Data.PayAmount;
          if (this.data.SendState > 0) {
            this.Back = true;
          } else {
            this.Back = false;
          }
          this.OrderInfos.push(res.Data);
        }
      });
      this.ogApi.list(params).then((res) => {
        if (res.Data) {
          this.OrderGoods = res.Data;
          this.OrderGoods.sort(
            (a, b) => a.AttributeOrderId - b.AttributeOrderId
          );
        }
      });
      this.olApi.list(params).then((res) => {
        if (res.Data) this.OrderLog = res.Data;
      });
      this.api.getDeliverDocList(this.data.RecordId).then((res) => {
        if (res.Data) this.DeliverList = res.Data;
      });
      this.api.getOrderLogistics(this.data.RecordId).then((res) => {
        if (res.Data) this.Logistics = res.Data;
      });
      if (data.RefundStatus > 0) {
        this.rgApi.list(params).then((res) => {
          if (res.Data) this.RefundList = res.Data;
        });
      }
    },
    beforeClose() {
      this.BackRemark = "";
      this.RefundAmount = null;
    },
    passRefund() {
      this.api
        .passRefund({
          OrderMainId: this.data.RecordId,
          Back: this.Back,
          RefundAmount: this.RefundAmount,
          Remark: this.BackRemark,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.show1 = false;
            this.close();
            this.$emit("close-saved");
          } else {
            this.$message.error(res.Msg);
          }
        });
    },
    refuseRefund() {
      this.$confirm("确认拒绝退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api
            .refuseRefund({
              OrderMainId: this.data.RecordId,
              Remark: this.BackRemark,
            })
            .then((res) => {
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                this.show2 = false;
                this.close();
                this.$emit("close-saved");
              } else {
                this.$message.error(res.Msg);
              }
            });
        })
        .catch(() => {});
    },
    backPass() {
      this.$confirm("确认收货并退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.backPass(this.data.RecordId).then((res) => {
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.show3 = false;
              this.close();
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    onClosed() {
      this.OrderGoods = [];
      this.OrderLog = [];
      this.DeliverList = [];
      this.RefundList = [];
      this.OrderInfos = [];
      this.Logistics = [];
    },
  },
};
</script>